
import React from 'react';

export const DestinationsSection: React.FC = () => {
  return (
    <section
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('/images/cruises-destinations.jpg')`
      }}
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="bg-white/95 backdrop-blur-sm rounded-lg p-8 md:p-12 shadow-xl max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            SAIL TO PICTURESQUE DESTINATIONS
          </h2>
          <div className="text-2xl md:text-3xl font-bold text-emerald-600 space-y-2">
            <div>MUMBAI ⇝ GOA</div>
            <div>KOCHI ⇝ LAKSHADWEEP</div>
          </div>
        </div>
      </div>
    </section>
  );
};
